<template>
  <div>
    <Header :selectedApp="selectedApp"></Header>
    <div class="col-12 d-inline-flex">
      <div class="col-10 no-overflow ms-3 me-3 pt-3" style="position: relative;">
        <h2>Plans</h2>
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex justify-content-between align-items-center">
            <a role="button" class="procricket-btn mb-3" @click="redirectToCreate">Create New Entry</a>
          </div>
          <input type="text" class="form-control mb-3" placeholder="Search in plans..." v-model="searchText" style="width: 20%; position: relative; ">
        </div>
        <div class="table-responsive">
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th class="col-1" @click="toggleSort('planName')">Plan Name</th>
                <th class="col-1" @click="toggleSort('description')">Description </th>
                <th class="col-1" @click="toggleSort('maxDevices')">Max Devices</th>
                <th class="col-1" @click="toggleSort('price')">Price</th>
                <th class="col-1" @click="toggleSort('duration')">Duration</th>
                <th class="col-1" @click="toggleSort('orderNumber')">Order Number</th>
                <th class="col-1" @click="toggleSort('application')">Application</th>
                <th class="col-1" @click="toggleSort('active')">Active</th>
                <th class="col-1" @click="toggleSort('status')">Status</th>
                <th class="col-1" @click="toggleSort('trial')">Trial</th>
                <th class="col-1" @click="toggleSort('updated')">Updated</th>
                <th class="col-1">Edit</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="config in sortData" :key="config.planId">
                <td class="col-1 text-truncate" v-html="truncateText(config.planName, 30)" ></td>
                <td class="col-1 text-truncate" v-html="truncateText(config.description, 30)" @click="selectText" :data-text="config.description"></td>
                <td class="col-1 text-truncate" v-html="truncateText(config.maxDevices, 30)" @click="selectText" :data-text="config.maxDevices"></td>
                <td class="col-1 text-truncate" v-html="truncateText(config.price, 30)" @click="selectText" :data-text="config.price"></td>
                <td class="col-1 text-truncate" v-html="truncateText(config.duration, 30)" @click="selectText" :data-text="config.duration"></td>
                <td class="col-1 text-truncate" v-html="truncateText(config.orderNumber, 30)" @click="selectText" :data-text="config.orderNumber"></td>
                <td class="col-1 text-truncate" v-html="truncateText(config.application, 30)" @click="selectText" :data-text="config.application"></td>
                <td class="col-1 text-truncate" v-html="truncateText(config.active, 30)" @click="selectText" :data-text="config.active"></td>
                <td class="col-1 text-truncate" v-html="truncateText(config.status, 30)" @click="selectText" :data-text="config.status"></td>
                <td class="col-1 text-truncate" v-html="truncateText(config.trial, 30)" @click="selectText" :data-text="config.trial"></td>
                <td class="col-1 text-truncate" v-html="functions.formatUnixTimestamp(config.updated)" @click="selectText" :data-text="config.updated"></td>
                <td class="col-1 centered">
                  <router-link :to="{ name: 'PlanEdit', params: { planId: config.planId, ...config } }" class="procricket-btn">
                    Edit
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import AdminService from "@/services/admin-service";
import Header from "@/components/Header.vue";
import Cookies from "js-cookie";
import functions from "@/functions";

export default {
  name: "Plans",
  components: {
    Header,
  },
  data() {
    return {
      searchText: '',
      PlansList: [],
      sortColumn: '',  // Add this property
      sortDirection: 'asc',
      selectedApp: ''
    };
  },
  computed: {
    functions() {
      return functions
    },
    filteredPlansList() {
      const search = this.searchText.toLowerCase().trim();
      let filteredList = this.PlansList.filter((config) => {
        return (
            (config.planName && config.planName.toLowerCase().includes(search)) ||
            (config.description && config.description.toLowerCase().includes(search)) ||
            (config.maxDevices && config.maxDevices.toString().includes(search)) ||
            (config.duration && config.duration.toLowerCase().includes(search)) ||
            (config.orderNumber && config.orderNumber.toString().includes(search)) ||
            (config.application && config.application.toString().includes(search)) ||
            (config.price && config.price.toString().includes(search)) ||
            (config.active && config.active.toString().includes(search)) ||
            (config.status && config.status.toString().includes(search)) ||
            (config.trial && config.trial.toString().includes(search)) ||
            (config.updated && config.updated.toString().includes(search)) // Assuming updated is a date field
        );
      });

      if (this.sortColumn) {
        const direction = this.sortDirection === 'asc' ? 1 : -1;
        filteredList = filteredList.sort((a, b) => {
          const valueA = a[this.sortColumn];
          const valueB = b[this.sortColumn];

          if (valueA < valueB) return -1 * direction;
          if (valueA > valueB) return 1 * direction;
          return 0;
        });
      }
      //Sort the table to include only the elements that have the selected application
      if (this.selectedApp !== '') {
        filteredList = filteredList.filter(item => item.application === this.selectedApp);
      }
      return filteredList;
    },
    sortData() {
      return this.filteredPlansList;
    },
  },
  created() {
    this.doLoadPlans();
    document.addEventListener('click', (event) => this.handleClickAnywhere(event));

    const appCookie = Cookies.get('application');
    if (appCookie) {
      this.selectedApp = appCookie;
    }

    this.sortColumn = 'planName';
  },
  methods: {
    doLoadPlans() {
      AdminService.getPlansList().then((data) => {
        this.PlansList = data;
      }).catch((error) => {
        console.error("Error loading plans:", error);
      });
    },
    wrapText(text, limit) {
      if (text.length > limit) {
        const firstLine = text.substring(0, limit);
        const secondLine = text.substring(limit);
        return `${firstLine}<br>${secondLine}`;
      } else {
        return text;
      }
    },
    truncateText(text, limit) {
      return text.length > limit ? text.substring(0, limit) + '...' : text;
    },
    redirectToCreate() {
      this.$router.push({ name: 'PlanCreate' });
    },
    async selectText(event) {
      const originalText = event.target.getAttribute('data-text');
      try {
        await navigator.clipboard.writeText(originalText);
        this.highlightElement(event.target);
      } catch (err) {
        console.error('Failed to copy text: ', err);
      }
    },
    highlightElement(element) {
      this.removeHighlight();
      element.style.backgroundColor = 'yellow'; // Add highlight
      this.highlightedElement = element;
      setTimeout(this.removeHighlight, 10000); // Remove highlight after 10 seconds
    },
    removeHighlight() {
      if (this.highlightedElement) {
        this.highlightedElement.style.backgroundColor = ''; // Remove highlight
        this.highlightedElement = null;
      }
    },
    handleClickAnywhere() {
      this.removeHighlight()
    },
    toggleSort(column) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortDirection = 'asc';
      }
    }
  },
};
</script>
<style src="../../assets/style.css">
</style>
